import axios from "axios";

const BASE = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const API = axios.create({ baseURL: BASE, withCredentials: true });

let refreshing = null;

API.interceptors.response.use(
  (r) => r,
  async (error) => {
    const orig = error.config;
    if (error.response?.status === 401 && orig && !orig._retried && !orig.url.includes("/auth/")) {
      orig._retried = true;
      try {
        refreshing =
          refreshing ||
          axios
            .post(`${BASE}/auth/refresh`, {}, { withCredentials: true })
            .finally(() => {
              refreshing = null;
            });
        await refreshing;
        return API(orig);
      } catch {
        // sessione scaduta: il contesto auth riportera' al login
      }
    }
    return Promise.reject(error);
  }
);

export function apiError(e, fallback = "Errore imprevisto") {
  const detail = e?.response?.data?.detail;
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map((x) => x?.msg || JSON.stringify(x)).join(" ");
  if (detail && typeof detail === "object" && typeof detail.msg === "string") return detail.msg;
  return e?.message || fallback;
}

export function eur(cents) {
  if (cents === null || cents === undefined) return "—";
  return new Intl.NumberFormat("it-IT", { style: "currency", currency: "EUR" }).format(cents / 100);
}

export function formatDateTime(value) {
  if (!value) return "—";
  const d = new Date(value);
  if (isNaN(d)) return "—";
  return d.toLocaleString("it-IT", { day: "2-digit", month: "2-digit", year: "numeric", hour: "2-digit", minute: "2-digit" });
}
